// extracted by mini-css-extract-plugin
module.exports = {"board":"ChangePassword_board_2KuMW","header":"ChangePassword_header_14bjb","title":"ChangePassword_title_1DozZ"};